import axiosInstance from "./utils";
import axios from "axios";
import store from "../store";

export default {
  getClients() {
    return axiosInstance
      .get("clients")
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on get clients", err);
        store.dispatch("add_error_queue", {
          error: err,
          message:
            "Une erreur est survenu lors de l'obtention de la liste des clients",
        });
      });
  },

  getLogoSignedUrl(clientId, imgType) {
    return axiosInstance
      .get(`uploads3/${clientId}?type=${imgType}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on get logo signed URL", err);
        store.dispatch("add_error_queue", {
          error: err,
          message:
            "Une erreur est survenu lors de la demande d'accès pour le logo",
        });
      });
  },

  updateLogo(signedURL, imageFile) {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    let formData = new FormData();
    formData.append("file", imageFile);
    return axios
      .put(signedURL, imageFile, { headers }, { s3: true })
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on update logo", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la mise à jour du logo",
        });
      });
  },

  updateClientInfo(clientId, data) {
    return axiosInstance
      .put(`clients/${clientId}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on update client", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la mise à jour du client",
        });
      });
  },

  createNewClient(data) {
    return axiosInstance
      .post(`stacks`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on create new client", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la création du client",
        });
      });
  },
};
